import { useEffect, useRef, useState } from "react"

import isEqual from "lodash-es/isEqual"

export function useDebounce<T>(value: T, timeout = 400, initialValue?: T) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [debouncedValue, setDebouncedValue] = useState(
    initialValue !== undefined ? initialValue : value
  )
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    if (!isEqual(value, debouncedValue)) {
      timeoutRef.current = setTimeout(() => {
        setDebouncedValue(value)
      }, timeout)
    }
  }, [value, debouncedValue])

  return debouncedValue
}
